import * as Zod from 'zod';

import { IExtraCategoryOption } from 'graphql/types';
import { dateTimeValidator } from 'common/validators/dateTime';

export const extraCategoryValidator = Zod.object({
    __typename: Zod.literal('ExtraCategory'),
    id: Zod.string(),
    name: Zod.string(),
    categoryType: Zod.enum(IExtraCategoryOption),
    showLabel: Zod.boolean(),
});

export const extraCategoryChoiceOptionValidator = Zod.object({
    __typename: Zod.literal('ExtraCategoryChoiceOption'),
    id: Zod.string(),
    stringValue: Zod.string(),
});

export const extraCategoryBooleanValue = Zod.object({
    __typename: Zod.literal('ExtraCategoryBooleanValue'),
    booleanValue: Zod.boolean(),
    modelId: Zod.string(),
    category: extraCategoryValidator,
});

export const extraCategoryChoiceValue = Zod.object({
    __typename: Zod.literal('ExtraCategoryChoiceValue'),
    modelId: Zod.string(),
    category: extraCategoryValidator,
    choiceValue: extraCategoryChoiceOptionValidator,
});

export const extraCategoryDatetimeValue = Zod.object({
    __typename: Zod.literal('ExtraCategoryDatetimeValue'),
    datetimeValue: Zod.coerce.date(),
    modelId: Zod.string(),
    category: extraCategoryValidator,
});

export const extraCategoryStringValue = Zod.object({
    __typename: Zod.literal('ExtraCategoryStringValue'),
    stringValue: Zod.string(),
    modelId: Zod.string(),
    category: extraCategoryValidator,
});

export const extraCategoryValuesValidator = Zod.array(
    Zod.union([
        extraCategoryBooleanValue,
        extraCategoryChoiceValue,
        extraCategoryDatetimeValue,
        extraCategoryStringValue,
    ])
);

const selectOptionValidator = Zod.object({
    label: Zod.string(),
    value: Zod.string(),
});

export const extraCategoryInputValidator = (optional?: boolean) => {
    const categoryValue = Zod.union([
        Zod.string(),
        Zod.array(selectOptionValidator),
        selectOptionValidator,
        Zod.boolean(),
        dateTimeValidator,
    ]);

    const valueSchema = optional
        ? categoryValue.optional().nullable()
        : categoryValue;

    return Zod.record(Zod.string(), valueSchema);
};
